module.exports = __webpack_public_path__ + "img/p1.1a9a3d3c.jpg";